// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__bO03b","containerItemsCenter":"Skeleton_containerItemsCenter__2uWzN"};